import React from 'react';
import { ImageInput } from 'components/common/Image/ImageInput';
import styles from './imageFormInput.module.scss';
import classNames from 'classnames/bind';

type ImageFormInputType = {
  className?: string;
  onChange: (imageData: ImageFieldData) => void;
  validTypes?: string[];
  errorBorderHint: boolean;
  url: string;
  file?: File;
  maxWidth?: number;
  maxHeight?: number;
};

export const ImageFormInput: React.FunctionComponent<ImageFormInputType> = ({
  validTypes = ['image/jpeg', 'image/jpg', 'image/png'],
  className,
  onChange,
  errorBorderHint,
  url,
  file,
  maxWidth,
  maxHeight
}) => {
  const cssClassNames = classNames.bind(styles);

  const onFileChange = (f) => {
    if (!f) {
      onChange &&
        onChange({
          file: undefined,
          url: undefined
        });
      return;
    }
    if (validTypes.indexOf(f.type) === -1) {
      onChange &&
        onChange({
          file: f,
          url: undefined
        });
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const image = new Image();
      const src = reader.result as string;
      image.src = src;
      image.onload = () => {
        onChange &&
          onChange({
            file: f,
            width: image.width,
            height: image.height,
            url: undefined,
            imgBase64: src
          });
      };
    };
    reader.readAsDataURL(f);
  };
  const mainClassName = cssClassNames('fileFormInput', className, {
    showErrorBorder: errorBorderHint,
    showSolidBorder: url || file
  });

  return (
    <div className={mainClassName}>
      <ImageInput
        validTypes={validTypes}
        errorBorderHint={errorBorderHint}
        url={url}
        file={file}
        maxWidth={maxWidth}
        maxHeight={maxHeight}
        onChange={onFileChange}
      />
    </div>
  );
};
